(function(){
    "use strict";
    
    angular
        .module("app")
        .component("account", { // account
            templateUrl: "src/app/account/account.html",
            controller: controller
        });

    function controller($http, session, toast) {
        const $ctrl = this;
        $ctrl.session = session;
        
        $ctrl.user = {
            user_id: session.user.user_id,
            first_name: session.user.first_name,
            last_name: session.user.last_name,
            password: "",
            password2: ""
        };
        $ctrl.ui = {
            isLoading: false,
            passwordUpdated: false,
            canContinue: () => {
                return !$ctrl.ui.isLoading && $ctrl.user.password && $ctrl.user.password2 && ($ctrl.user.password === $ctrl.user.password2);
            },
            passwordsDontMatch: () => {
                return $ctrl.user.password && $ctrl.user.password2 && ($ctrl.user.password !== $ctrl.user.password2);
            },
            passwordErrors: []
        };

        $ctrl.saveNewPasswordClicked = () => {
            $ctrl.ui.passwordUpdated = false;
            $ctrl.ui.passwordErrors = [];
            $ctrl.ui.isLoading = true;
            $http
                .post(`/api/users/change-password-self/`, { password: $ctrl.user.password })
                .then(result => {
                    if (result.data[0].is_valid) {
                        toast.success("Set Password", "Password has been saved.");
                        $ctrl.user.password = "";
                        $ctrl.user.password2 = "";
                        $ctrl.ui.passwordUpdated = true;
                    } else {
                        $ctrl.ui.passwordErrors = result.data.filter(d => !d.is_valid);
                    }
                })
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.isLoading = false);
        };
    }
    controller.$inject = ["$http", "sessionService", "stToastFactory"];
    
})()